import { render, staticRenderFns } from "./RegimeTributario.vue?vue&type=template&id=0457e2b6&scoped=true&"
import script from "./RegimeTributario.vue?vue&type=script&lang=js&"
export * from "./RegimeTributario.vue?vue&type=script&lang=js&"
import style0 from "./RegimeTributario.vue?vue&type=style&index=0&id=0457e2b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0457e2b6",
  null
  
)

export default component.exports